// extracted by mini-css-extract-plugin
export default {"uploadRes":"AssignmentPanel_uploadRes__ezfjx","formControl":"AssignmentPanel_formControl__dMMZg","lastFiveRes":"AssignmentPanel_lastFiveRes__fjwmk"};